import {
  ID,
  SortingMode,
  Task,
  TaskListTreeItem,
  Timestamp,
  WeekDays,
} from '@griply/types';
import { buildTypeTree } from '@griply/utils';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type Options = {
  tasks: Task[];
  customOrder?: Record<ID, ID[]>;
  sortingMode?: SortingMode | null;
  today: Timestamp;
  weekStartsOn: WeekDays;
  showEmptyGroups?: boolean;
  hideNewTaskRow?: boolean;
};

export const useTypeTree = ({
  tasks,
  customOrder,
  sortingMode,
  today,
  weekStartsOn,
  showEmptyGroups,
  hideNewTaskRow,
}: Options) => {
  const { t } = useTranslation();
  const tasksLabel = t('general.sections.type.tasks.title');
  const habitsLabel = t('general.sections.type.habits.title');

  return useMemo<Record<ID, TaskListTreeItem>>(
    () =>
      buildTypeTree({
        tasks,
        customOrder,
        sortingMode,
        today,
        weekStartsOn,
        showEmptyGroups,
        hideNewTaskRow,
        tasksLabel,
        habitsLabel,
        rootLabel: 'Root',
        newTaskLabel: 'New Task',
        newHabitLabel: 'New Habit',
      }),
    [
      customOrder,
      sortingMode,
      tasks,
      today,
      weekStartsOn,
      showEmptyGroups,
      hideNewTaskRow,
      tasksLabel,
      habitsLabel,
    ],
  );
};
